import { string } from 'yup';
import { FIREBASE_ID_LENGTH } from '../../helpers';

export const ReferralIdentifierSchema = string()
  .length(FIREBASE_ID_LENGTH)
  .matches(/^[a-zA-Z0-9]+$/, 'Referral identifier must be alphanumeric');
